import { useQuery } from "@tanstack/react-query";
import { getApiPracticesPracticeIdPatientsPatientId } from "@/lib/api-client/endpoints/patient/patient";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { PatientDetailResponse } from "lib/api-types/schemas";
import { useEffect } from "react";

export const patientDetailsQueryKey = (practiceId: string, patientId: string) =>
  ["patients", "details", practiceId, patientId] as const;

export function usePatientDetails(
  patientId: string | null,
  onError?: VoidFunction,
) {
  const { tenantId } = useTenantRouteContext();

  const query = useQuery<PatientDetailResponse>({
    queryKey: patientDetailsQueryKey(tenantId, patientId ?? ""),
    queryFn: () =>
      getApiPracticesPracticeIdPatientsPatientId(tenantId, patientId!).then(
        (res) => res.data,
      ),
    enabled: patientId !== null,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) onError?.();
  }, [query.isError, onError]);

  return query;
}
